import { Tooltip, useDrawer } from '@iveco-ti/iveco-ds'
import { FileSearch, Fingerprint } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { UserApplicationAccountUserPaginated } from '../hooks/usePaginateUserApplicationAccountUser'
import { useSelectedUserApplicationAccountUserStore } from '../stores/useSelectedUserApplicationAccountUserStore'

type ActionsApplicationAccountProps = {
  userAccess: UserApplicationAccountUserPaginated
}

export function ActionsApplicationAccount({
  userAccess,
}: ActionsApplicationAccountProps) {
  const { t } = useTranslation(['common', 'sso'])
  const { toggleSelectedUserAccess } =
    useSelectedUserApplicationAccountUserStore()
  const drawerManageUserAccess = useDrawer(
    'drawer-manage-application-account-user',
  )
  const drawerViewApplicationAccountUser = useDrawer(
    'drawer-view-application-account-user',
  )

  return (
    <div className="flex flex-row gap-2 items-center justify-center">
      <Tooltip text={t('common:components.table_row.view')}>
        <button
          type="button"
          className="p-1 hover:bg-base-100 rounded"
          onClick={() => {
            toggleSelectedUserAccess(userAccess)
            drawerViewApplicationAccountUser.open()
          }}
        >
          <FileSearch size={18} className="text-brand-700" />
        </button>
      </Tooltip>

      <Tooltip text={t('sso:access.table_row.manage')}>
        <button
          type="button"
          className="p-1 hover:bg-base-100 rounded"
          onClick={() => {
            toggleSelectedUserAccess(userAccess)
            drawerManageUserAccess.open()
          }}
        >
          <Fingerprint size={18} className="text-brand-700" />
        </button>
      </Tooltip>
    </div>
  )
}
